import { mapActions } from 'vuex';

export default {
  name: 'Card',
  computed: {
    isImageBased() {
      return !!this.item.image;
    },
    label() {
      return !this.item.backgroundColor ? this.item.symbol : '';
    },
    canFlip() {
      return this.item.flipped || this.item.matched;
    },
    hasScriptFont() {
      return this.item.font === 'script';
    },
    hasPrintFont() {
      return this.item.font === 'print';
    },
    isColorLabel() {
      return this.item.font === 'print-small';
    }
  },
  methods: {
    ...mapActions(['flipCard'])
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
